<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="nanas"></div><div class="pear"></div>
        <div class="awan"></div><div class="awan2"></div>
        <div class="theContent">
          <div class="profileImg" :class="name"><img :src="imgUri"></div>
          <div class="profile" v-if="name === 'dhelya'">
            <p>Dr. dr. Dhelya Widasmara Sp.KK (K) FINSDV, merupakan
              dokter spesialis kulit dan kelamin yang berdomisili di
              kota Malang, yang dikenal luas sebagai pembicara, edukator,
              dosen, penulis dan pemilik pusat kesehatan kulit dan
              kelamin di kota Malang(@elbeclinic dan @skinlevelclinic).</p>
            <p>Sosok nya dikenal lewat kanal youtube (dr.dhelya) instagram
              ( @dhelya_spkk) dan tiktok (@drdhelyaspkk). dokter Dhelya
              biasa dipanggil dengan dr.lala atau lebih dikenal dengan
              nama tenar "doc La". Berani terjun kedunia maya karena
              membawa misi edukasi dengan memberikan informasi “yang benar”
              dari banyaknya berita hoax soal kesehatan terutama kesehatan
              kulit dan kelamin yang banyak beredar di masyarakat, hal ini
              memotivasi doc La rutin memberi informasi kesehatan dan edukasi
              melalui website pribadinya dan kanal youtube ,tiktok serta
              instagram miliknya. Doc La meraih rekor Muri untuk siaran
              langsung edukasi kesehatan kulit terlama melalui instagram.</p>
          </div>
          <div class="profile" v-else-if="name === 'clark'">
            <p>Bergelar PhD dari Universitas Shanghai, dengan fokus di
              "Science of Chinese Traditional Medicine", telah membawanya
              menjadi Sr. Scientist of Nutrition Investigation
              di Amway (China) R&D Center. Dr. Chen bertanggung jawab
              untuk mendesain formula, validasi manfaat,  pembuktian
              klaim  dan dukungan ilmiah untuk produk TCM dan priobiotik</p>
          </div>
          <div class="profile" v-else-if="name === 'sarah'">
            <p>Awalnya dikenal publik Indonesia sebagai VJ MTV.
              Tidak hanya sebagai presenter, Sarah juga terjun ke
              dunia film dan drama televisi. Film yang pernah
              dibintanginya antara lain "Perempuan Punya Cerita",
              "Arisan! 2" dan berhasil meraih Aktris Pembantu
              Terfavorit dan masuk nominasi Aktris Pembantu Terbaik,
              dan meraih Presenter Wanita terbaik
              dari Anugerah Komisi Penyiaran Indonesia di tahun 2015.</p>
          </div>
          <div class="profile" v-else-if="name === 'yura'">
            <p>Seorang penyanyi solo dan juga penulis lagu kelahiran Bandung.
              Yura sudah mulai mengarang lagu sejak usia 15 tahun dan
              mengeluarkan Album pertamanya di tahun 2014. Prestasi yang
              pernah diraih Yura adalah "The Best Female Singer in Indonesia"
              berturut turut di tahun 2017 & 2018 AMY AWARDS and Best
              Songwriter "Intuisi" 2017. Yura juga meraih penghargaan
              sebagai "99 Most Influential  & Inspiring Woman" di
              acara12th Globe Asia 2019 </p>
          </div>
          <div class="profile" v-else-if="name === 'testimoni'">
            <div class="q">
              <h4>Yandi Effendi</h4>
              <p>Karyawan & Entrepreneur</p>
            </div>
            <div class="q">
              <h4>Bernardette Maria</h4>
              <p>Business Owner & Health and Beauty Enthusiast</p>
            </div>
            <div class="q">
              <h4>Cinthya Angeline</h4>
              <p>Health & Beauty Enthusiast</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      imgUri: null,
      name: null,
    };
  },
  methods: {
    open(d, n) {
      this.name = d;
      if (d !== 'testimoni') this.imgUri = `https://storage.googleapis.com/deepdivedjkt/clg/speakers/${d}.png`;
      else this.imgUri = 'https://storage.googleapis.com/deepdivedjkt/clg/speakers/speaker-testimoni.png';
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  @media (max-width: 680px) {
    padding: 20px 10px;
  }
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background-color: #ffc9ca;
    background-image: url(../assets/mainstage-bg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 740px;
    margin: auto;
    border-radius: 5px;
    padding: 0;
    overflow: hidden;
    transition: all .3s ease;
    @media (max-width: 780px) {
      width: auto;
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0;
    }
    .theContent{
      position: relative;
      z-index: 3;
      padding: 40px 100px;
      overflow: auto;
      box-sizing: border-box;
      max-height: 680px;
      @media (max-height: 760px) {
        max-height: 520px;
      }
      @media (max-width: 680px) {
        padding: 40px 20px;
      }
    }
    .profileImg{
      text-align: center;
      position: relative;
      z-index: 3;
      img{
        max-height: 300px;
        max-width: 100%;
        @media (max-width: 680px) {
          max-height: 200px;
        }
      }
      &.dhelya{
        img{
          max-height: 260px;
          margin-top: 20px;
        }
      }
      &.clark{
        @media (max-width: 680px) {
          margin-left: -30px;
        }
      }
    }
    h4{
      margin: 0 0 -20px;
      text-align: center;
      font-size: 30px;
      @media (max-width: 680px) {
        font-size: 22px;
      }
    }
    p{
      position: relative;
      font-size: 19px;
      line-height: 1.2;
      z-index: 3;
      text-align: center;
      @media (max-width: 680px) {
        font-size: 16px;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 20px;
      top: 10px;
      // opacity: .4;
      cursor: pointer;
      z-index: 9;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
  }
}

.nanas{
  position: absolute;
  left: 20px; top: 300px;
  width: 80px; height: 80px;
  background-image: url(../assets/Mainstage-Buah1.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: fruitAnimation 10s infinite ease;
}
.pear{
  position: absolute;
  right: 80px; top: 140px;
  width: 120px; height: 120px;
  background-image: url(../assets/Mainstage--Buah2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  animation: fruitAnimation 10s infinite ease;
}
.awan{
  background-image: url(../assets/Mainstage-Awan3.png);
  width: 340px; height: 340px;
  position: absolute;
  top: 0; left: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  animation: fruitAnimation2 8s infinite ease;
}
.awan2{
  background-image: url(../assets/Mainstage-Awan2.png);
  width: 200px; height: 200px;
  position: absolute;
  top: 80px; right: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  animation: fruitAnimation2 8s infinite ease;
}
@keyframes fruitAnimation {
  0% {transform: translateY(0);}
  50% {transform: translateY(14px);}
  100% {transform: translateY(0);}
}
@keyframes fruitAnimation2 {
  0% {transform: translateY(14px);}
  50% {transform: translateY(0);}
  100% {transform: translateY(14px);}
}
</style>
